<template>
  <div>
    我的课表
  </div>
</template>

<script setup>

</script>

<style lang="less" scoped>

</style>
